import { Component, Vue } from 'vue-property-decorator'
import { getWorkOrderSign, setWorkOrderStatus, getChangeCourseOrder, getChangeTeacherOrder, queryRefundOrder } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
@Component({ name: 'ApproveDetailSign' })
export default class ApproveDetailSign extends Vue {
  private orderId: any = null
  private signType: any = 0 // 1-转案审批 2-续报审批 3-更换项目审批 4-更换导师审批
  private rejectReason = '' // 驳回理由
  private project = {}
  private teacher = {}
  private rejectDialogVisible = false // 驳回面板是否显示
  private orderData: any = null // 工单信息
  private pageAction: any = '' // 页面操作
  private informationListImg: any =[]
  created () {
    this.orderId = this.$route.query.id
    this.signType = Number(this.$route.query.type)
    this.pageAction = this.$route.query.action
    this.initPageData()
  }

  private async initPageData () {
    let result: any = null
    if (this.signType === 3) {
      result = await getChangeCourseOrder({ id: this.orderId })
      this.project = result.newCourse
      result = result.student
    } else if (this.signType === 1 || this.signType === 2 || this.signType === 0) {
      result = await getWorkOrderSign({ id: this.orderId })
    } else if (this.signType === 4) {
      result = await getChangeTeacherOrder({ id: this.orderId })
      this.teacher = result.teacher
      result = result.student
    } else if (this.signType === 7) {
      result = await queryRefundOrder({ id: this.orderId })
    }
    this.orderData = result
    // 简历部分预览【】
    const list1: any = JSON.parse(JSON.stringify(this.orderData.resumeUrlList))
    const resumeUrlList: any = []
    list1.forEach((item: any) => {
      if (item) {
        const url = decodeURI(item)
        const str = url.split('/crm/')[1]
        if (str) {
          const name = str.slice(20)
          const obj = { name: name, url: item }
          resumeUrlList.push(obj)
        }
        if (this.fileExtension(item) === 'png' || this.fileExtension(item) === 'jpg' || this.fileExtension(item) === 'jpeg') {
          this.informationListImg.push(item)
        }
      }
    })
    this.orderData.resumeUrlList = resumeUrlList
  }

  fileExtension = function (type: any) {
    return type.substring(type.lastIndexOf('.') + 1)
  }

  /**
   * [description] 驳回按钮点击
   */
  private async onRejectClick () {
    await setWorkOrderStatus({ id: this.orderId, status: 2, comment: this.rejectReason })
    this.rejectDialogVisible = false
    this.$message({ message: '操作成功', type: 'success' })
    TagsViewModule.delView(this.$route)
    this.$router.go(-1)
  }

  /**
   * [description] 通过按钮点击
   */
  private onPassClick () {
    this.$confirm('确认提交信息无误', { showCancelButton: false, confirmButtonText: '知道了', type: 'info', confirmButtonClass: 'message-ok' }).then(async () => {
      await setWorkOrderStatus({ id: this.orderId, status: 1 })
      if (this.signType === 4) {
        this.$message({ message: '审批通过，替换导师成功', type: 'success' })
      } else {
        this.$message({ message: '操作成功', type: 'success' })
      }
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    })
  }
}
